import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  EDIT_SURVEY,
  GET_QUESTION,
  LIST_SURVEY,
  MAIL_INVITE,
  SAVE_QUESTION_ANSWER,
  LIST_HORIZONTAL,
  LIST_VERTICAL,
  FINAL_SUBMISSION_QUESTIONS_ANSWERS
} from "./actionTypes"
import { 
  surveySuccess, 
  surveyError , 
  horizontalSuccess,
  horizontalError ,
  verticalSuccess,
  verticalError,
  getQuestionSuccess ,
  getQuestionError 
} from "./actions"

import {
  surveyEdit,
  surveyList,
  mailInvite,
  onSaveQuestionAnswer,
  onSaveFinalsubmissionQuestionAnswer,
  getQuestionById,
  getHorizontalList,
  getVerticalList 
} from "helpers/backend_api_helper";



// Save question
function* saveQuestionAnswer({ payload: { data, type, callback } }) {
  try {
    const response = yield call(onSaveQuestionAnswer, data, type);
    yield put(surveySuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyError(error?.response?.data?.message || "Server Error"));
  }
}

//Final submission question anwer
function* finalSubmissionQuestionAnswers({ payload: { data, type, callback } }) {
  try {
    const response = yield call(onSaveFinalsubmissionQuestionAnswer, data, type);
    yield put(surveySuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Language
function* editSurvey({ payload: { data, id, callback } }) {
  try {
    const response = yield call(surveyEdit, data, id);
    yield put(surveySuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyError(error?.response?.data?.message || "Server Error"));
  }
}

//  Get Question
function* getQuestion({ payload: {id, type, callback } }) {
  try {
    const response = yield call(getQuestionById, id, type);
    yield put(getQuestionSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(getQuestionError(error?.response?.data?.message || "Server Error"));
  }
}

// Mail invite
function* mailInviteSurvey({ payload: { data, callback } }) {
  try {
    const response = yield call(mailInvite, data);
    yield put(surveySuccess(response));
    callback && callback(response);

  } catch (error) {
    callback && callback(error?.response);
    yield put(surveyError(error?.response?.data?.message || "Server Error"));
  }
}

// list Language
function* listSurvey({ payload: { type, callback } }) {
  try {
    const response = yield call(surveyList, type);
    yield put(surveySuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyError(error?.response?.data?.message || "Server Error"));
  }
}



function* horizontalList({ payload: { type, callback } }) {
  try {
    const response = yield call(getHorizontalList, type);
    yield put(horizontalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(horizontalError(error?.response?.data?.message || "Server Error"));
  }
}

function* verticalList({ payload: { type, callback } }) {
  try {
    const response = yield call(getVerticalList, type);
    yield put(verticalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(verticalError(error?.response?.data?.message || "Server Error"));
  }
}

function* SurveySaga() {
  yield takeEvery(EDIT_SURVEY, editSurvey);
  yield takeEvery(LIST_SURVEY, listSurvey);
  yield takeEvery(MAIL_INVITE, mailInviteSurvey);
  yield takeEvery(GET_QUESTION, getQuestion);
  yield takeEvery(SAVE_QUESTION_ANSWER, saveQuestionAnswer);
  yield takeEvery(FINAL_SUBMISSION_QUESTIONS_ANSWERS, finalSubmissionQuestionAnswers);
  yield takeEvery(LIST_HORIZONTAL, horizontalList);
  yield takeEvery(LIST_VERTICAL, verticalList);
}

export default SurveySaga;

